import React, {  useEffect } from 'react'
import "./loginPageStyle.scss"
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from "@hookform/error-message"
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom'
import { AuthState } from '../context/AuthProvider'
import { SocketState } from '../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux';
import { SET_MAIN_LOADER } from '../redux/loaderSlice';
import { SET_LOGIN_FORM_ERROR, SelectLoginFormError } from '../redux/errorMessageSlice';


/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  user_name: yup.string().required('You must enter a user name.'),
  password: yup
    .string()
    .required('Please enter your password.')
    .min(4, 'Password is too short - must be at least 4 chars.'),
});

const defaultValues = {
  user_name: JSON.parse(localStorage.getItem('creditionlsDetails'))?.user_name || '',
  password: JSON.parse(localStorage.getItem('creditionlsDetails'))?.password || '',
};


function LoginPage() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const navigate = useNavigate();
  const LoginFormError = useSelector(SelectLoginFormError)

  const { control, formState, handleSubmit, setError, setValue } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });


  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    // setValue('email', 'admin@fusetheme.com', { shouldDirty: true, shouldValidate: true });
    // setValue('password', 'admin', { shouldDirty: true, shouldValidate: true });
  }, [setValue]);



  function onSubmit({ user_name, password }) {
    dispatch(SET_LOGIN_FORM_ERROR(null))
    dispatch(SET_MAIN_LOADER(true))
    // socket call
    let payload = {
      "en": "AppLunchDetails",
      "data": {
        user_name,
        password
      }
    }

    localStorage.setItem('creditionls', JSON.stringify({ user_name, password }))
    localStorage.setItem('creditionlsDetails', JSON.stringify({ user_name, password }))
    socket?.emit("req",payload)
  }





  return (
    <div className='flex flex-1 h-screen items-center justify-center LoginContainer'>

      <div className="w-full max-w-xs">
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="mb-4">
                <button
                className="bg-[#93CCDD] hover:bg-[#499ab3] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                onClick={() => {navigate(`/result`);}}
                
              >
                10/30/50 CHART
              </button>
                <button
                className="bg-[#FCD5B4] mt-1 hover:bg-[#bf936d] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                onClick={() => {navigate(`/result3d`);}}
                
              >
                3D RESULT
              </button>
              
              <button
                className="bg-[#75e0d7] mt-1 hover:bg-[#9EEFE8] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                onClick={() => {navigate(`/result1d`);}}
                
              >
                2D RESULT
              </button>
              
              <button
                className="bg-[#EEBAD0] mt-1 hover:bg-[#EEBAD0] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                onClick={() => {navigate(`/result2d`);}}
                
              >
                4D RESULT
              </button>
                <button
                className="bg-[#FECAD5] mt-1 hover:bg-[#FECAD5] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                onClick={() => {navigate(`/resultTitli`);}}
                
              >
                TITLI RESULT
              </button>
              <button className="bg-[#FE4AD5] mt-1 hover:bg-[#FE4AD5] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full" onClick={() => navigate('/resultPana')}>
                Pana Result
              </button>
              {/* <img src="images/logo-removebg-preview1.png" alt="shree raj logo" className='logo-img'/> */}
            </div>
          <form
            name="loginForm"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            
              {LoginFormError && <p className='text-red-700 text-[13px] text-center font-bold mb-2'>{LoginFormError}</p>}
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="username"
              >
                Username*
              </label>
              <Controller
                name="user_name"
                control={control}
                render={({ field }) => (
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    type="text"
                    placeholder="Username"
                    {...field}
                  />
                )} />
                <ErrorMessage errors={errors} name="user_name" render={({message })=><p className="text-red-500">{message }</p>} />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password*
              </label>
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                  type="password"
                  placeholder="******************"
                    {...field}
                  />
                )} />
                <ErrorMessage errors={errors} name="password" render={({message })=><p className="text-red-500">{message }</p>} />
            </div>
            <div className="flex items-center justify-between">
              <button
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                type="submit"
                
              >
                Login
              </button>

            </div>
          </form>
        </div>
        <p className="text-center text-gray-500 text-xs">
          ©2023 Acme Corp. All rights reserved.
        </p>
      </div>


    </div>
  )
}

export default LoginPage  